import {isEmbedded, isProdAdminEmbedded} from './detection'
import {setBodyClass} from './setBodyClass'

const IS_EMBEDDED = isEmbedded()
const IS_PRODADMIN_EMBEDDED = isProdAdminEmbedded()

export {
  IS_EMBEDDED,
  IS_PRODADMIN_EMBEDDED,
  setBodyClass
}



// WEBPACK FOOTER //
// ./src/embedded/index.js